export const ValidarModal = ({ validadoPor, setValidadoPor, onCancel, onConfirm }) => (
  <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 50, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
    <div style={{ background: "white", borderRadius: 16, padding: 24, maxWidth: 320, width: "100%", textAlign: "center" }}>
      <p className="text-4xl mb-3">✅</p>
      <h3 className="font-bold text-gray-800 text-lg mb-2">Validar formulario</h3>
      <p className="text-gray-500 text-sm mb-4">Introduce el nombre de quien valida este formulario.</p>
      <input
        className="w-full border rounded-lg px-3 py-2 text-sm mb-4 focus:outline-none focus:ring-2 focus:ring-green-400"
        placeholder="Nombre del validador *"
        value={validadoPor}
        onChange={e => setValidadoPor(e.target.value)}
      />
      <div className="flex gap-3">
        <button onClick={onCancel} className="flex-1 bg-gray-100 text-gray-700 font-bold py-2 rounded-lg hover:bg-gray-200">Cancelar</button>
        <button
          disabled={!validadoPor.trim()}
          onClick={onConfirm}
          className="flex-1 bg-green-500 text-white font-bold py-2 rounded-lg hover:bg-green-600 disabled:opacity-40"
        >Confirmar</button>
      </div>
    </div>
  </div>
);
